import React, { useEffect, useState } from "react";

const useDotsLoader = (delay: number = 400) => {
  const [dots, setDots] = useState<string>("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === "...") {
          return "";
        } else {
          return prev + ".";
        }
      });
    }, delay);

    return () => clearInterval(interval);
  }, [delay]);

  return dots;
};

export default useDotsLoader;
